<template>
  <div class="headerStarAssignment">
    <h1>Asignación de Estrellas</h1>
    <v-container v-if="!formData.assignTypeName">
      <v-row no-gutters>
        <v-col md="3" sm="6" class="pa-2" v-for="(item, i) in cards" :key="i">
          <v-card class="cardStyle">
            <div class="d-flex flex-no-wrap justify-space-around">
              <div>
                <v-card-title>{{ item.categoryName }}</v-card-title>
                <v-card-title class="text-h5">{{
                  item.shapeCount
                }}</v-card-title>
              </div>
              <v-avatar class="avatarStyle" size="60">
                <div class="icon-item">
                  <img :src="item.icon" />
                </div>
              </v-avatar>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-if="formData.assignTypeName === 'Todos'">
      <v-row no-gutters>
        <v-col
          md="3"
          sm="6"
          class="pa-2"
          v-for="(item, i) in categorizedCards"
          :key="i"
        >
          <v-card :class="item.isGrayedOut ? 'cardStyle-gray' : 'cardStyle'">
            <div class="d-flex flex-no-wrap justify-space-around">
              <div>
                <v-card-title>{{ item.categoryName }}</v-card-title>
                <v-card-title class="text-h5">{{
                  item.shapeCount
                }}</v-card-title>
              </div>
              <v-avatar class="avatarStyle" size="60">
                <v-img :src="item.icon" max-width="40" max-height="40"></v-img>
              </v-avatar>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-if="formData.assignTypeName == 'Individual'">
      <v-row no-gutters>
        <v-col
          md="3"
          sm="6"
          class="pa-2"
          v-for="(item, i) in getIndividualCategorizedCards"
          :key="i"
        >
          <v-card :class="item.isGrayedOut ? 'cardStyle-gray' : 'cardStyle'">
            <div class="d-flex flex-no-wrap justify-space-around">
              <div>
                <v-card-title>{{ item.categoryName }}</v-card-title>
                <v-card-title class="text-h5">{{
                  item.shapeCount
                }}</v-card-title>
              </div>
              <v-avatar class="avatarStyle" size="60">
                <v-img :src="item.icon" max-width="40" max-height="40"></v-img>
              </v-avatar>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-row no-gutters>
      <v-col cols="12">
        <div class="assign">
          <v-select
            color="secondary"
            label="Asignar por"
            placeholder="Selecciona para asignar"
            :items="typeAssign"
            item-text="assignTypeName"
            item-value="assignTypeName"
            v-model="formData.assignTypeName"
          ></v-select>
        </div>
      </v-col>
    </v-row>
    <template>
      <div v-if="formData.assignTypeName === 'Todos'">
        <assignstarAll
          :typeCategory="this.typeCategory.listRecognitionCategoryParameters"
          :affiliatesCount="this.typeCategory.affiliateCount"
          :maxRecognitionCount="this.typeCategory.maxRecognitionCount"
        />
      </div>
    </template>
    <template>
      <div v-if="formData.assignTypeName == 'Individual'">
        <assignstarIndividual />
      </div>
    </template>
  </div>
</template>

<script>
import assignstarAll from "@/views/star_assignment/pages/star_assignment/components/form_assignment_all_component.vue";
import assignstarIndividual from "@/views/star_assignment/pages/star_assignment/components/form_assignment_individual_component.vue";
import {
  ACTION_GET_CARDS,
  RECOGNITION_BUYING_M,
  GET_CARDS,
} from "@/views/recognition/store/types/types.js";

import {
  STARASSIGNMENT_M,
  ACTION_GET_STARASSIGNMENT_LIST,
  GET_STARASSIGNMENT_LIST,
  GET_STARASSIGNMENT_TYPE_CATEGORY,
  ACTION_GET_CARDSlIST,
  GET_CARDSLIST,
} from "@/views/star_assignment/store/types/types.js";

import { mapActions, mapGetters } from "vuex";

export default {
  name: "mainStarAssignmentComponent",
  components: {
    assignstarAll,
    assignstarIndividual,
  },
  data() {
    return {
      dialog: false,
      formData: {},
      typeIdentificationData: [],
      categories: [],
      destinationUsers: [],
    };
  },

  async mounted() {
    await this.getCards();
    await this.getActionTypeAssign();
  },

  methods: {
    closeDialog() {
      this.dialog = false;
      window.location.reload();
    },

    ...mapActions({
      getCards: `${RECOGNITION_BUYING_M}${ACTION_GET_CARDS}`,
      getCardsList: `${STARASSIGNMENT_M}${ACTION_GET_CARDSlIST}`,
      getActionTypeAssign: `${STARASSIGNMENT_M}${ACTION_GET_STARASSIGNMENT_LIST}`,
    }),
  },

  computed: {
    ...mapGetters({
      cards: `${RECOGNITION_BUYING_M}${GET_CARDS}`,
      cardsList: `${STARASSIGNMENT_M}${GET_CARDSLIST}`,
      typeAssign: [`${STARASSIGNMENT_M}${GET_STARASSIGNMENT_LIST}`],
      typeCategory: [`${STARASSIGNMENT_M}${GET_STARASSIGNMENT_TYPE_CATEGORY}`],
    }),

    categorizedCards() {
      const affiliatesCount = Number(this.typeCategory.affiliateCount);
      return this.cards.map((card) => {
        card.isGrayedOut = card.shapeCount < affiliatesCount;
        return card;
      });
    },
    getIndividualCategorizedCards() {
      return this.cards.map((card) => {
        const cardInCardsList = this.cardsList.find(
          (cardListItem) => cardListItem.categoryName === card.categoryName
        );
        if (!cardInCardsList) {
          return {
            ...card,
            isGrayedOut: true,
          };
        }
        return {
          ...card,
          isGrayedOut: false,
        };
      });
    },
  },
};
</script>

<style lang="css" scoped>
body {
  font-family: "Nunito Sans", sans-serif;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Amsi Pro", sans-serif;
  color: #2d0049;
  font-weight: normal;
}

.avatarStyle {
  background-color: white !important;
}

.icon-item {
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon-item img {
  width: 100%;
  height: 100%;
  object-fit: contain; 
}

.cardStyle {
  border: 3px solid;
  border-color: #f2b37b;
  border-radius: 15px;
}

.cardStyle-gray {
  border: 3px solid #ccc;
  background-color: #f0f0f0;
  border-radius: 15px;
  color: #888;
}

.headerStarAssignment {
  display: flex;
  gap: 30px;
  flex-direction: column;
  margin-top: 20px;
  margin-left: 20px;
}

.avatarStyle {
  background-color: white;
}

.custom-font {
  font-size: 20px;
}

.inputCantidad {
  text-align: center;
  color: #2d0049;
  border: 2px solid;
  border-radius: 10px;
  border-color: #6e17a5;
  background-color: #eadcf3;
}

.inputCantidad-disabled {
  color: #888;
  background-color: #f0f0f0;
  border-color: #ccc;
}

.subtotal {
  text-align: right;
  color: #6e17a5;
  padding: 0 60px;
  font-size: 23px;
  font-weight: 500;
}

.disabled-btn {
  background-color: #ccc !important;
  color: #fff !important;
}

.assign {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  max-width: 300px;
  padding: 16px;
}

@media screen and (max-width: 414px) {
  h1 {
    font-size: 3vh;
    margin-left: 2vh;
  }

  .custom-font {
    font-size: 13px;
  }

  .subtotal {
    text-align: right;
    color: #6e17a5;
    margin: auto;
    padding: 45px 10px;
    font-size: 23px;
    font-weight: 500;
  }
}

@media screen and (min-width: 414px) {
  h1 {
    font-size: 4vh;
    margin-left: 2vh;
  }
}

@media screen and (max-width: 280px) {
  h1 {
    font-size: 3vh;
    margin-left: 2vh;
  }

  h2 {
    font-size: 2vh;
  }

  .custom-font {
    font-size: 13px;
  }
}

.container {
  position: relative;
}

.v-btn.fixed {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
}
</style>
